<template>
    <v-container id="paymentForm-form-wrapper">
        <!-- <v-row column justify-center align-center
            ><v-col cols="12">{{ isShippingCountryUS }}</v-col
            ><v-col cols="12">{{ shippingDetails }}</v-col
            ><v-col cols="12">{{ checkoutForm }}</v-col></v-row
        > -->
        <v-row
            v-show="isLoggedIn && isCheckoutDetailsComplete"
            column
            justify-center
            align-center
        >
            <v-col cols="12">
                <v-container class="pa-0">
                    <v-row column justify-center align-center>
                        <v-col
                            cols="12"
                            md="8"
                            offset-md="2"
                            :class="{
                                'pa-0': true,
                                'd-flex': true,
                                'justify-center': !$vuetify.breakpoint
                                    .smAndDown,
                            }"
                        >
                            <v-card-title class="py-0"
                                ><span>
                                    <TranslatableStringComponent
                                        :tstring="{
                                            string: 'reviewSubmitOrder',
                                        }"
                                    /> </span
                            ></v-card-title>
                        </v-col>
                        <!-- <v-col cols="12" md="8" offset-md="2" class="pa-0">
                            <v-card-title class="py-0"
                                >Order Addresses:
                            </v-card-title>
                        </v-col> -->
                        <v-col cols="12" md="4" offset-md="2">
                            <v-card>
                                <v-card-title
                                    class="d-flex flex-column align-start"
                                    ><span>
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'billingAddress',
                                            }"
                                        /> </span
                                    ><ContactCardTitle
                                        :contact="billingDetails"
                                /></v-card-title>
                                <v-card-text>
                                    <ContactCardDetails
                                        :contact="billingDetails"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-card>
                                <v-card-title
                                    class="d-flex flex-column align-start"
                                    ><span>
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'shippingAddress',
                                            }"
                                        /> </span
                                    ><ContactCardTitle
                                        :contact="shippingDetails"
                                /></v-card-title>
                                <v-card-text>
                                    <ContactCardDetails
                                        :contact="shippingDetails"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="8" offset-md="2" class="pa-0">
                            <v-card-title class="py-0"
                                ><span
                                    ><TranslatableStringComponent
                                        :tstring="{
                                            string: 'orderTotal',
                                        }" /></span
                                >:&nbsp;<strong
                                    >${{ total.toFixed(2) }}</strong
                                ></v-card-title
                            >
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
            <v-col cols="12">
                <v-col
                    cols="12"
                    md="8"
                    offset-md="2"
                    :class="{
                        'pa-0': true,
                        'd-flex': true,
                        'justify-center': !$vuetify.breakpoint.smAndDown,
                    }"
                >
                    <v-card-title class="py-0"
                        ><span>
                            <TranslatableStringComponent
                                :tstring="{ string: 'paymentDetails' }"
                            /> </span
                    ></v-card-title>
                </v-col>
                <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <v-form
                        id="paymentForm"
                        ref="paymentForm"
                        data-netlify="true"
                        data-netlify-honeypot="bot-field"
                        name="paymentForm"
                        action="/payment/"
                        method="POST"
                        @submit.prevent="handleSubmit(handleSubmission)"
                    >
                        <v-container class="pa-0">
                            <v-row column justify-center align-center>
                                <v-col cols="12" md="8 " offset-md="2">
                                    <div v-show="isShippingCountryUS">
                                        <v-card class="pa-5 mb-5">
                                            <v-alert
                                                v-show="
                                                    isApprovedForTerms &&
                                                    !payNow
                                                "
                                                dense
                                                outlined
                                                type="info"
                                                color="#0063a6"
                                                class="body-2"
                                            >
                                                <div>
                                                    <span>
                                                        <TranslatableStringComponent
                                                            :tstring="{
                                                                string:
                                                                    'approvedForPaymentTerms',
                                                            }"
                                                        /> </span
                                                    ><strong v-if="ARTerm">
                                                        ({{
                                                            ARTerm.name
                                                        }})</strong
                                                    >.
                                                    <span>
                                                        <TranslatableStringComponent
                                                            :tstring="{
                                                                string:
                                                                    'provideAPONumber',
                                                            }"
                                                        /> </span
                                                    >&nbsp;<strong>
                                                        <TranslatableStringComponent
                                                            :tstring="{
                                                                string:
                                                                    'placeOrder',
                                                            }"
                                                        />
                                                    </strong>
                                                </div>
                                            </v-alert>
                                            <ValidationProvider
                                                name="purchaseOrderNumber"
                                                :rules="isPOrequired"
                                                class="validationWrapper"
                                            >
                                                <div slot-scope="{ errors }">
                                                    <span
                                                        class="validationMessage"
                                                    >
                                                        {{ errors[0] }}
                                                    </span>
                                                    <v-text-field
                                                        id="purchaseOrderNumber"
                                                        v-model="
                                                            purchaseOrderNumber
                                                        "
                                                        name="purchaseOrderNumber"
                                                        :label="`${localize(
                                                            'purchaseOrderNumber'
                                                        )} ${
                                                            isPOrequired
                                                                ? `(${localize(
                                                                      'required'
                                                                  )})`
                                                                : `(${localize(
                                                                      'optional'
                                                                  )})`
                                                        }`"
                                                        hide-details="false"
                                                        outlined
                                                        dense
                                                    ></v-text-field>
                                                </div>
                                            </ValidationProvider>
                                        </v-card>
                                        <v-switch
                                            v-show="isApprovedForTerms"
                                            v-model="payNow"
                                            color="success"
                                            :label="localize('wishToPayNow')"
                                            hide-details="false"
                                            class="mb-5 mt-0"
                                        ></v-switch>

                                        <div
                                            v-if="
                                                isLoggedIn &&
                                                webUser &&
                                                ![
                                                    'devops@c3controls.com',
                                                ].includes(webUser.email)
                                            "
                                        >
                                            <PaymentGatewayTemplate
                                                @setPaymentMethod="
                                                    setPaymentMethod($event)
                                                "
                                                :cardValidationErrorMessage="
                                                    cardValidationErrorMessage
                                                "
                                                v-show="
                                                    payNow ||
                                                    !isApprovedForTerms
                                                "
                                            />
                                        </div>
                                        <div v-else>
                                            <v-card>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <!-- BILLING HEADING -->
                                                            <h2 class="mb-0">
                                                                <TranslatableStringComponent
                                                                    :tstring="{
                                                                        string:
                                                                            'cardDetails',
                                                                    }"
                                                                />
                                                            </h2>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <!-- BILLING MESSAGE -->
                                                            <TranslatableBlockComponent
                                                                :tstring="{
                                                                    string:
                                                                        'placeOrderToCheckoutWithoutPaymentNote',
                                                                }"
                                                            />
                                                            <!-- <p>
                                                        <span>Contact </spanu
                                                        ><a
                                                            href="mailto:customerfirst@c3controls.com"
                                                            >customerfirst@c3controls.com</a
                                                        >
                                                        or
                                                        <a
                                                            href="tel:+17247757926"
                                                            >(724) 775-7926</a
                                                        >
                                                        with any questions (not
                                                        required to complete
                                                        checkout)
                                                    </p> -->
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card>
                                        </div>
                                    </div>
                                    <div v-show="!isShippingCountryUS">
                                        <h4>
                                            <TranslatableStringComponent
                                                :tstring="{
                                                    string:
                                                        'internationalShippingNoticePart1',
                                                }"
                                            />
                                        </h4>
                                        <br />
                                        <TranslatableBlockComponent
                                            :tstring="{
                                                string:
                                                    'internationalShippingNotice2',
                                            }"
                                        />
                                        <v-card class="pa-5 mb-5">
                                            <ValidationProvider
                                                name="purchaseOrderNumber"
                                                :rules="isPOrequired"
                                                class="validationWrapper"
                                            >
                                                <div slot-scope="{ errors }">
                                                    <span
                                                        class="validationMessage"
                                                    >
                                                        {{ errors[0] }}
                                                    </span>
                                                    <v-text-field
                                                        id="purchaseOrderNumber"
                                                        v-model="
                                                            purchaseOrderNumber
                                                        "
                                                        name="purchaseOrderNumber"
                                                        :label="`${localize(
                                                            'purchaseOrderNumber'
                                                        )} (${localize(
                                                            'required'
                                                        )})`"
                                                        hide-details="false"
                                                        outlined
                                                        dense
                                                    ></v-text-field>
                                                </div>
                                            </ValidationProvider>
                                        </v-card>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="8" offset-md="2">
                                    <ValidationProvider
                                        name="tnc"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-checkbox
                                                v-model="tnc"
                                                name="tnc"
                                                class="checkbox-slot"
                                            >
                                                <template v-slot:label>
                                                    <TranslatableBlockComponent
                                                        :tstring="{
                                                            string:
                                                                'termsAndCondition',
                                                        }"
                                                    />
                                                </template>
                                            </v-checkbox>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="8" offset-md="2">
                                    <v-btn type="submit" color="success" right>
                                        <TranslatableStringComponent
                                            :tstring="{ string: 'placeOrder' }"
                                        />
                                    </v-btn>

                                    <div v-if="submission.sending">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string:
                                                    'submittingCheckoutForm',
                                            }"
                                        />
                                    </div>
                                    <div v-else-if="submission.waiting">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'awaitingCheckoutForm',
                                            }"
                                        />
                                    </div>
                                    <div v-else-if="submission.success">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string:
                                                    'successfulCheckoutForm',
                                            }"
                                        />
                                    </div>
                                    <div v-else-if="submission.failure">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'failedCheckoutForm',
                                            }"
                                        />
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </ValidationObserver>
            </v-col>
            <v-col cols="12">
                <v-overlay :value="overlay">
                    <div class="d-flex flex-column align-center">
                        <v-progress-circular
                            :size="70"
                            :width="4"
                            color="#408abc"
                            indeterminate
                        ></v-progress-circular>
                        <p>
                            <TranslatableStringComponent
                                :tstring="{ string: `${processingMessage}` }"
                            />
                        </p>
                    </div>
                </v-overlay>
            </v-col>
        </v-row>
        <v-row
            v-show="showIncompleteDetailsError"
            column
            justify-center
            align-center
        >
            <v-col cols="12">
                <div class="text-center">
                    <!-- Please add your billing/shipping information. -->
                    {{ `Incomplete checkout details. Redirecting...` }}
                </div>
            </v-col>
        </v-row>
        <v-row v-show="!isLoggedIn" column justify-center align-center>
            <v-col cols="12">
                <FormLogin :heading="true" />
            </v-col>
        </v-row>
        <v-row v-if="debug">
            <v-col
                >DEBUG ONLY:
                <pre>{{ billingDetails }}</pre>
            </v-col>
        </v-row>
        <v-overlay :value="overlay">
            <div class="d-flex flex-column align-center">
                <v-progress-circular
                    :size="70"
                    :width="4"
                    color="#408abc"
                    indeterminate
                ></v-progress-circular>
                <p>
                    <TranslatableStringComponent
                        :tstring="{ string: `${processingMessage}` }"
                    />
                </p>
            </div>
        </v-overlay>
    </v-container>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import Cookies from 'js-cookie'
import { gtmEvent } from '~/plugins/global'
import formUtilities from '~/mixins/formUtilities'
import encodeFormData from '~/mixins/encodeFormData'
import FormLogin from '~/components/forms/FormLogin.vue'
import handleSnackbar from '~/mixins/handleSnackbar'
import handleAuth from '~/mixins/handleAuth'
import countries from '~/util/arrays/countries.js'
import ContactCardDetails from '~/components/ContactCardDetails'
import ContactCardTitle from '~/components/ContactCardTitle'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import TranslatableBlockComponent from '~/components/TranslatableBlockComponent.vue'
import { localize } from 'vee-validate'
import PaymentGatewayTemplate from '~/components/PaymentGateway/PaymentGatewayTemplate.vue'
export default {
    name: 'FormPayment',
    components: {
        FormLogin,
        ContactCardDetails,
        ContactCardTitle,
        PaymentGatewayTemplate,
        TranslatableStringComponent,
        TranslatableBlockComponent,
    },
    directives: { mask },
    mixins: [encodeFormData, formUtilities, handleSnackbar, handleAuth],
    head() {
        return {
            script: [
                {
                    // src: '/js/invoiced.js'
                    src: 'https://js.invoiced.com/v1/',
                },
            ],
        }
    },
    data() {
        return {
            cart: [],
            isCart: false,
            isCheckout: true,
            errorMessage: '',
            submission: {
                sending: false,
                waiting: false,
                success: false,
                failure: false,
            },
            selectedPaymentMethod: '',
            orderProducts: [],

            payNow: false,
            cardValidationErrorMessage: '',
            last4: '',
            invoicedGatewayId: '',
            overlay: false,
            processingMessage: '',
            loggedIn: false,
            tnc: null,
            showIncompleteDetailsError: false,
            erpWebOrderSubmission: null,
            customerCreateResponse: null,
            cardMessage: '',
            cardFailed: false,
        }
    },
    computed: {
        ...mapGetters({
            total: 'cart/fetchCartTotal',
            subtotal: 'cart/fetchCartSubtotal',
            taxTotal: 'cart/fetchCartTaxTotal',
            taxRate: 'cart/fetchCartTaxRate',
            cartProducts: 'cart/fetchCartProducts',
            availableCartProducts: 'cart/fetchAvailableCartProducts',
            tariffTotal: 'cart/fetchCartTariffTotal',
            shippingDetails: 'checkout/getShippingDetails',
            handlingFee: 'cart/fetchHandlingFee',
            handlingFeePerItemTotal: 'cart/fetchHandlingFeePerItemTotal',
            billingDetails: 'checkout/getBillingDetails',
            salesRep: 'checkout/salesRep',
            selectedShippingMethodPrice: 'cart/fetchSelectedMethodPrice',
            isCarrierVendorDetailsEmpty: 'cart/isCarrierVendorDetailsEmpty',
            isShipperNumberValidationTrue: 'cart/isShipperNumberValidationTrue',
            isCustomerCreated: 'auth/isCustomerCreated',
            shippingMethod: 'cart/fetchShippingMethod',
            isShippingTBD: 'cart/isShippingTBD',
            isInternationalShipping: 'checkout/isInternationalShipping',
            isCouponValid: 'coupon/isCouponValid',
            discountValue: 'coupon/discountValue',
            abandonedCartPresent: 'abandonedCartNew/isAbandonedCartPresent',
            getCustomerPrimaryContactQuery:
                'customerDetails/getCustomerPrimaryContactQuery',
            getCustomerPrimaryContact:
                'customerDetails/getCustomerPrimaryContact',
            getCustomerName: 'customerDetails/getCustomerName',
            ARTerm: 'auth/ARTerm',
            billingAddressForOrder: 'checkout/billingAddressForOrder',
            shippingAddressForOrder: 'checkout/shippingAddressForOrder',
            webOrderPayloadNew: 'cart/webOrderPayloadNew',
            inventoryLineItems: 'cart/inventoryLineItems',
            nonInventoryLineItems: 'cart/nonInventoryLineItems',
            primaryCustomer: 'auth/primaryCustomer',
            finalARTerm: 'auth/finalARTerm',
            appliedShippingChargesList: 'cart/appliedShippingChargesList',
            fetchShippingCharges: 'cart/fetchShippingCharges',
        }),
        ...mapState('checkout', [
            'checkoutForm',
            'purchaseOrderNumber',
            'orderMessage',
            'billingFormArray',
            'selectedBillingAddressID',
            'selectedShippingAddressID',
        ]),
        ...mapState('customProducts', ['customProductList']),
        ...mapState('cart', [
            'selectedCarrierMethod',
            'selectedShippingMethod',
            'shipperNumber',
            'carrierVendorName',
            'internationalShippingMethod',
            'customerCreateResponseId',
        ]),
        ...mapState('coupon', ['couponCode']),
        ...mapState('auth', ['webUser']),
        ...mapState('customerDetails', ['primaryContact']),
        ...mapState('paymentGateway', ['creditCardForm', 'achForm']),
        debug() {
            return process.env.DEBUG_ON === 'true'
        },
        showCheckoutButton() {
            return false
        },
        isShippingCountryUS() {
            return (
                this.shippingDetails &&
                ['United States', 'Canada'].includes(
                    this.shippingDetails.addressCountry
                )
            )
        },
        creditCardlast4() {
            return this.creditCardForm.cardNumber.split(' ')[3]
        },
        expiryMonth() {
            return this.creditCardForm?.expiryDate?.split('/')[0]?.trim()
        },
        expiryYear() {
            return `20${this.creditCardForm?.expiryDate?.split('/')[1]?.trim()}`
        },
        purchaseOrderNumber: {
            get() {
                return this.$store.state.checkout.purchaseOrderNumber
            },
            set(value) {
                this.$store.commit('checkout/updatePurchaseOrderNumber', value)
            },
        },
        isPOrequired() {
            return this.isApprovedForTerms && !this.payNow ? 'required' : ''
        },
        isCheckoutDetailsComplete() {
            if (
                this.billingFormArray.length > 0 &&
                this.selectedBillingAddressID &&
                this.selectedShippingAddressID
            ) {
                if (
                    this.carrierVendorName === 'FedEx' &&
                    this.carrierVendorName === 'UPS' &&
                    this.carrierVendorName === 'DHL'
                ) {
                    if (
                        !this.isCarrierVendorDetailsEmpty &&
                        this.isShipperNumberValidationTrue
                    ) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return true
                }
            }
            return false
        },
        erpPaymentMethod() {
            if (this.payNow || !this.isApprovedForTerms) {
                if (this.selectedPaymentMethod === 'creditCard') {
                    return 'CC'
                } else if (this.selectedPaymentMethod === 'ach') {
                    return 'ACH'
                } else {
                    return null
                }
            } else {
                return null
            }
        },
        webOrderNo() {
            if (this.erpWebOrderSubmission) {
                return this.erpWebOrderSubmission.uoid
            } else {
                return undefined
            }
        },
    },
    watch: {
        isCustomerCreated(newValue, oldValue) {
            if (!newValue) {
                this.routerPush({ type: 'page', slugName: 'customer-details' })
            }
        },
    },
    mounted() {
        if (!this.isCheckoutDetailsComplete) {
            this.showIncompleteDetailsError = true
            this.routerPush({ type: 'page', slugName: 'checkout' })
        }
    },
    methods: {
        isCustomProductFound(cartItem) {
            let isCustomProductFound, customPn, customDescription
            if (this.customProductList.length > 0) {
                isCustomProductFound = this.customProductList.find((item) => {
                    return item.pn === cartItem.pn
                })
                if (isCustomProductFound) {
                    customPn = cartItem.pn
                    const customInputString = isCustomProductFound.legendPlateInput
                        .map((item) => {
                            return `${item.label} : ${item.value}`
                        })
                        .join(' , ')
                    customDescription = `${customPn} - ${cartItem.name_en} - ( ${customInputString} ) `.substr(
                        0,
                        399
                    )
                }
            }
            return {
                isCustomProductFound,
                customPn,
                customDescription,
            }
        },
        isNumber(evt) {
            evt = evt || window.event
            const charCode = evt.which ? evt.which : evt.keyCode
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault()
            } else {
                return true
            }
        },
        handleLoadingState(stateString) {
            if (stateString === 'sending') {
                this.submission.sending = true
                this.submission.waiting = false
                this.submission.success = false
                this.submission.failure = false
            } else if (stateString === 'waiting') {
                this.submission.sending = false
                this.submission.waiting = true
                this.submission.success = false
                this.submission.failure = false
            } else if (stateString === 'success') {
                this.submission.sending = false
                this.submission.waiting = false
                this.submission.success = true
                this.submission.failure = false
            } else if (stateString === 'failure') {
                this.submission.sending = false
                this.submission.waiting = false
                this.submission.success = false
                this.submission.failure = true
            } else {
                // clear all loading states
                this.submission.sending = false
                this.submission.waiting = false
                this.submission.success = false
                this.submission.failure = false
            }
        },
        setPaymentMethod(paymentMethod) {
            this.selectedPaymentMethod = paymentMethod
        },
        tokenizeCreditCard() {
            return new Promise((resolve, reject) => {
                const pubKey = process.env.INVOICED_PUB_KEY
                // console.log('pubKey', pubKey)
                window.Invoiced.setPublishableKey(pubKey)

                const number = this.creditCardForm.cardNumber
                const cvc = this.creditCardForm.cvc
                const expMonth = this.expiryMonth
                const expYear = this.expiryYear
                const name = this.creditCardForm.cardHolder
                let countryObj
                if (this.billingDetails.addressCountry.length > 3) {
                    countryObj = countries.find(
                        (item) =>
                            item.name === this.billingDetails.addressCountry
                    )
                } else if (this.billingDetails.addressCountry.length === 3) {
                    countryObj = countries.find(
                        (item) =>
                            item.alpha3code ===
                            this.billingDetails.addressCountry
                    )
                } else if (this.billingDetails.addressCountry.length === 2) {
                    countryObj = countries.find(
                        (item) =>
                            item.alpha2code ===
                            this.billingDetails.addressCountry
                    )
                } else {
                    countryObj = {
                        alpha2code: this.billingDetails.addressCountry,
                    }
                }
                const address = {
                    address1: this.billingDetails.address1,
                    city: this.billingDetails.addressCity,
                    state: this.billingDetails.addressState,
                    postal_code: this.billingDetails.addressPostalCode,
                    country: countryObj.alpha2code,
                }

                if (this.debug) {
                    console.log(
                        'DEBUG ONLY: address for tokenization is',
                        address
                    )
                }

                const handleInvoicedToken = (statusCode, response) => {
                    if (statusCode >= 400) {
                        reject(new Error(response.message))
                        this.cardValidationErrorMessage = response.message
                    } else {
                        resolve(response)
                        this.cardValidationErrorMessage = ''
                        this.handleLoadingState('sending')
                        // console.log(
                        //     'Success! Send this token to the backend for the next step: ',
                        //     response.id
                        // )
                    }
                }
                window.Invoiced.card.tokenize(
                    number,
                    cvc,
                    expMonth,
                    expYear,
                    name,
                    address,
                    handleInvoicedToken
                )
            })
        },
        tokenizeAch() {
            return new Promise((resolve, reject) => {
                const pubKey = process.env.INVOICED_PUB_KEY
                // console.log('pubKey', pubKey)
                window.Invoiced.setPublishableKey(pubKey)

                const name = this.achForm.accountName
                const accountType = this.achForm.accountType
                const accountNumber = this.achForm.accountNumber
                const routingNumber = this.achForm.routingNumber

                const handleInvoicedToken = (statusCode, response) => {
                    if (statusCode >= 400) {
                        // console.log(response)
                        reject(new Error(response.message))
                        this.cardValidationErrorMessage = response.message
                    } else {
                        resolve(response)
                        this.cardValidationErrorMessage = ''
                        this.handleLoadingState('sending')
                        // console.log(
                        //     'Success! Send this token to the backend for the next step: ',
                        //     response
                        // )
                    }
                }
                window.Invoiced.bankAccount.tokenize(
                    name,
                    accountType,
                    accountNumber,
                    routingNumber,
                    handleInvoicedToken
                )
            })
        },
        async fetchTokenResposnse() {
            switch (this.selectedPaymentMethod) {
                case 'creditCard':
                    return await this.tokenizeCreditCard()
                case 'ach':
                    return await this.tokenizeAch()
                default:
                    return
            }
        },
        async handlePayment() {
            const tokenResponse = await this.fetchTokenResposnse()
            const payload = {
                tokenID: tokenResponse.id,
                last4: tokenResponse.source.last4,
                expiryMonth: tokenResponse.source.exp_month,
                expiryYear: tokenResponse.source.exp_year,
                customerDetails:
                    this.customerCreateResponse || this.primaryCustomer,
                invoicedCustomerId: this.primaryCustomer?.invoicedCustomerId,
                erpCustomerId:
                    this.primaryCustomer?.id || this.customerCreateResponseId,
                isApprovedForTerms: this.isApprovedForTerms,
                objectType: tokenResponse.source.object,
                routingNumber: tokenResponse.source.routing_number,
            }
            const response = await this.$axios.post('payment-gateway', payload)
            if (this.debug) {
                console.log('###### Payment Done #######', response.data)
            }
            this.last4 = response.data.last4
            this.invoicedGatewayId = response.data.gatewayId
            this.cardMessage = response.data.message
            this.cardFailed = !response.data.success
        },
        async createCustomerInERP() {
            const payload = {
                name: this.getCustomerName,
                CustomerPrimaryContact: this.getCustomerPrimaryContactQuery,
                Territory: {
                    connect: {
                        intacctTerritoryId:
                            this.salesRep && this.salesRep.territory
                                ? this.salesRep.territory
                                : 'TEST',
                    },
                },
                CustRep: {
                    connect: {
                        name:
                            this.salesRep && this.salesRep.rep
                                ? this.salesRep.rep
                                : 'DH',
                    },
                },
                PriceList: {
                    connect: {
                        intacctPriceListName: 'OEM',
                    },
                },
                ARTerm: {
                    connect: {
                        name: 'CREDIT CARD',
                    },
                },
                WebUsers: {
                    connect: [
                        {
                            id: this.webUser.id,
                        },
                    ],
                },
                PrimaryCustomerForWebUsers: {
                    connect: [
                        {
                            id: this.webUser.id,
                        },
                    ],
                },
                taxable: this.getCustomerPrimaryContact.taxable,
                taxVerificationNote: this.getCustomerPrimaryContact.taxable
                    ? `Set via first web order by ${
                          this.getCustomerPrimaryContact.nameFirst
                      } ${
                          this.getCustomerPrimaryContact.nameLast
                      } on ${new Date()}`
                    : '',
                taxVerificationCompleted: !!this.getCustomerPrimaryContact
                    .taxable,
                Segment: {
                    connect: {
                        id: 5,
                    },
                },
            }
            const response = await this.$axios.post(
                'erp-customer?method=create',
                {
                    ...payload,
                }
            )
            return response
        },
        async fetchWebOrderInERP() {
            const payload = {
                uoid: this.erpWebOrderSubmission.uoid,
            }
            const response = await this.$axios.post(
                'erp-order?method=read',
                payload
            )
            return response
        },
        async submitWebOrder() {
            const payload = {
                ...this.webOrderPayloadNew,
                inventoryLineItems: this.inventoryLineItems,
                nonInventoryLineItems: this.nonInventoryLineItems,
                uoid: Math.floor(Date.now() / 1000),
                docNo: Date.now().toString(),
                cardLast4: this.last4,
                cardMessage: this.cardMessage,
                cardFailed: this.cardFailed,
                invoicedGatewayId: this.invoicedGatewayId,
                paymentMethod: this.erpPaymentMethod,
                cardBuyerEmail1: this.webUser.email,
                isShipItComplete: this.isShippingCountryUS
                    ? this.$store.state.checkout.isShipItComplete
                    : true,
                CreatedByWebUserEmail: this.webUser.email,
                ARTermName: this.payNow ? 'CREDIT CARD' : this.finalARTerm,
                appliedShippingChargesList: this.appliedShippingChargesList,
                isWeb: true,
            }
            const response = await this.$axios.post(
                'erp-order?method=create',
                payload
            )
            // console.log(response)
            return response
        },
        async emailConfirmationViaMailgun() {
            const res = await this.fetchWebOrderInERP()
            const webOrderDocNo = res.data?.orders[0].docNo
            if (this.debug) {
                console.log(
                    'DEBUG ONLY: webOrderPayload is',
                    this.erpWebOrderSubmission
                )
                console.log(
                    'DEBUG ONLY: webOrderConfirmationToken is',
                    this.webOrderNo
                )
            }

            const {
                OrderLine,
                shippingPoNumber,
                messageFromCustomer,
                tax,
                shippingAccountNumber,
                shippingAccountCarrier,
                isInx,
                cardLast4,
            } = this.erpWebOrderSubmission
            const billingDetails = this.billingDetails
            const shippingDetails = this.shippingDetails
            const tariffTotal = this.tariffTotal
            const handlingFee = this.handlingFee + this.handlingFeePerItemTotal
            const selectedShippingMethodPrice = this.selectedShippingMethodPrice
            const selectedCarrierMethod = this.selectedCarrierMethod
            const hubspotutk = Cookies.get('hubspotutk')
            const products = this.cartProducts.map((c) => {
                const {
                    pn,
                    name_en,
                    salePrice,
                    prod_quantity,
                    subTotalSalePrice,
                    parent,
                } = c
                return {
                    pn,
                    name_en,
                    salePrice,
                    prod_quantity,
                    subTotalSalePrice,
                    parent: parent.en.current,
                }
            })

            // const InventoryItems = OrderLine.filter(
            //     (i) => i.Item.type === 'Inventory'
            // ).sort((a, b) => (a.orderLineNo > b.orderLineNo ? 1 : -1))

            const response = await this.$axios.post(
                'submitted-web-form',
                {
                    'form-name': 'paymentForm',
                    products: products,
                    docNo: webOrderDocNo,
                    shippingPoNumber,
                    messageFromCustomer,
                    tax,
                    subtotal: this.subtotal,
                    orderTotal: this.total,
                    shippingAccountNumber,
                    shippingAccountCarrier,
                    isInx,
                    cardLast4,
                    billingDetails,
                    shippingDetails,
                    tariffTotal,
                    handlingFee,
                    couponCode: this.isCouponValid && this.couponCode,
                    couponDiscountValue: this.discountValue,
                    hasTariff: tariffTotal > 0 ? true : false,
                    selectedShippingMethodPrice,
                    oversizedShippingCharges: this.fetchShippingCharges,
                    selectedCarrierMethod,
                    hubspotutk,
                },
                {
                    params: {
                        obj: 'y',
                    },
                }
            )
            // console.log('response from MailGun is ', response)
            return response.data
        },
        googleAnalytics() {
            if (this.debug) {
                console.log('erpWebOrderSubmission', this.erpWebOrderSubmission)
            }
            const gaTotalQty = this.erpWebOrderSubmission.OrderLine.map(
                function (b) {
                    return b.orderLineQty
                }
            ).reduce(function (p, c) {
                return p + c
            })
            // console.log('gaTotalQty', gaTotalQty)
            const gaProducts = this.erpWebOrderSubmission.OrderLine.map(
                (item) => {
                    return {
                        // List of productFieldObjects.
                        name: item.itemName || 'Part Number not recorded', // Name or ID is required. // pn
                        id: item.Item.itemId || 'Item ID not recorded',
                        price: item.orderLineActualPrice || 0,
                        brand: 'c3controls',
                        category:
                            item.Item.productLine ||
                            'Product Line not recorded',
                        // variant: 'Gray',
                        quantity: item.orderLineQty,
                        coupon: '', // Optional fields may be omitted or set to empty string.
                        // dimension20: item.categories[0],
                        // dimension21: item.categories[1],
                        // dimension22: item.categories[2],
                        // dimension23: item.categories[3],
                        // dimension24: item.categories[4],
                        // dimension25: item.categories[5],
                        // dimension26: item.categories[6],
                        // dimension27: item.categories[7],
                        // dimension28: item.categories[8],
                        // dimension29: item.categories[9],
                    }
                }
            )
            gtmEvent({
                gtm: this.$gtm,
                event: 'paymentForm',
                eventType: 'order',
                atts: {
                    recordNo: `WO-${this.erpWebOrderSubmission.id}`,
                    ecommerce: {
                        purchase: {
                            actionField: {
                                id: `WO-${this.erpWebOrderSubmission.id}`, // Transaction ID. Required for purchases and refunds.
                                affiliation: 'c3controls.com',
                                revenue: this.erpWebOrderSubmission.total, // Total transaction value (incl. tax and shipping)
                                tax: this.erpWebOrderSubmission.tax,
                                shipping: 0, // this.selectedShippingMethodPrice,
                                quantity: gaTotalQty || 1, // total quantity of all items
                                coupon: '',
                            },
                            products: gaProducts,
                        },
                    },
                },
            })
        },
        async createWebOrderDynamoDb() {
            const resp = await this.$axios.post('dynamodb-create-web-order', {
                ...this.webOrderPayloadNew,
                inventoryLineItems: this.inventoryLineItems,
                nonInventoryLineItems: this.nonInventoryLineItems,
                uoid: Math.floor(Date.now() / 1000),
                docNo: Date.now().toString(),
                cardLast4: this.last4,
                cardMessage: this.cardMessage,
                cardFailed: this.cardFailed,
                cardInvoicedId: this.invoicedGatewayId,
                cardBuyerEmail1: this.webUser.email,
                isShipItComplete: this.isShippingCountryUS
                    ? this.$store.state.checkout.isShipItComplete
                    : true,
                CreatedByWebUserEmail: this.webUser.email,
                ARTermName: this.payNow ? 'CREDIT CARD' : this.finalARTerm,
                isWeb: true,
            })
            return resp
        },
        async handleSubmission() {
            let webOrderCreateResponse = null
            let isSuccess = true
            let orderLogDetails = 'Order Complete'

            try {
                // INIT
                this.overlay = true
                this.processingMessage = 'doNotRefreshPage'

                // DYNAMO DB (Raw order submission)
                webOrderCreateResponse = await this.createWebOrderDynamoDb()

                //  #########   c3 ERP - CUSTOMER    ##########
                //  *********  New Customer Creation **********
                if (!this.isCustomerCreated && !this.customerCreateResponseId) {
                    this.processingMessage = 'verifyingCustomerDetails'

                    const customerResponse = await this.createCustomerInERP()
                    if (customerResponse?.response?.errors.length > 0) {
                        throw new Error(
                            'Customer not created during order submission'
                        )
                    } else {
                        this.$store.commit(
                            'cart/setCustomerCreateResponseId',
                            customerResponse?.data.createCustomer?.id
                        )
                        this.customerCreateResponse =
                            customerResponse?.data.createCustomer
                    }
                    if (this.debug) {
                        console.log(
                            'DEBUG ONLY +++++++++ Customer verification ++++++++++++',
                            customerResponse
                        )
                    }
                }

                // INVOICED.COM
                if (
                    // this.isLoggedIn &&
                    // this.webUser &&
                    // ['devops@c3controls.com'].includes(this.webUser.email)
                    (this.payNow || !this.isApprovedForTerms) &&
                    this.isShippingCountryUS
                ) {
                    this.processingMessage = 'validatingPaymentOption'
                    await this.handlePayment()
                }

                //  #########   c3 ERP - ORDER    ##########
                //  *********  Web Order Creation **********
                this.processingMessage = 'submittingYourOrder'
                const webOrderResponse = await this.submitWebOrder()
                if (webOrderResponse?.response?.errors.length > 0) {
                    throw new Error(
                        'Web Order not created during order submission '
                    )
                } else {
                    this.erpWebOrderSubmission =
                        webOrderResponse.data.createOrderInTransaction
                }
                if (this.debug) {
                    console.log(
                        'DEBUG ONLY +++++++++ Customer verification ++++++++++++',
                        webOrderResponse
                    )
                }
                // MAILGUN
                this.processingMessage = 'sendingOrderConfirmationEmail'
                const mailgunResponse = await this.emailConfirmationViaMailgun()
                if (mailgunResponse.statusCode >= 400) {
                    isSuccess = false
                    orderLogDetails =
                        'Error occured at Mailgun : Mail Confirmation not sent.'
                }
                // console.log('mailgunResponse is', mailgunResponse)
                if (this.debug) {
                    console.log(
                        'DEBUG ONLY: mailgunResponse is',
                        mailgunResponse
                    )
                }

                // GOOGLE ANALYTICS
                this.googleAnalytics()

                // set VUEX store to DEFAULT VALUE
                // if (process.env.DEBUG_ON !== 'true') {
                this.$store.dispatch('cart/clearCart')
                this.$store.commit('checkout/clearCheckout')
                this.$store.commit('priceList/setSelectedPriceListId', '')
                this.$store.commit('priceList/setAppliedPriceList', [])
                this.$store.commit('customProducts/empty')
                this.$store.dispatch('coupon/removeCoupon')
                this.$store.dispatch('paymentGateway/clearPaymentFields')
                if (this.abandonedCartPresent)
                    this.$store.dispatch('abandonedCartNew/deleteErpCart')
                // }

                //  DYNAMO DB (Update Order status : **SUCCESSFUL**)
                await this.$axios.post('dynamodb-update-web-order', {
                    id: webOrderCreateResponse.data.id,
                    uoid: this.erpWebOrderSubmission?.uoid,
                    docNo: this.erpWebOrderSubmission?.docNo,
                    erpId: this.erpWebOrderSubmission?.id,
                    createdAt: webOrderCreateResponse.data.createdAt,
                    isSuccess,
                    orderLogDetails,
                    webOrderNo: this.webOrderNo,
                })
                this.$store.dispatch('auth/fetchWebUser')
                // Redirect to order-details page
                this.routerPush({
                    type: 'page',
                    slugName: 'order-details',
                    query: {
                        orderNo: `${this.webOrderNo}`,
                        new: `y`,
                    },
                })
            } catch (error) {
                //  DYNAMO DB (Update Order status : **FAILURE**)
                await this.$axios.post('dynamodb-update-web-order', {
                    id: webOrderCreateResponse.data.id,
                    createdAt: webOrderCreateResponse.data.createdAt,
                    isSuccess: false,
                    orderLogDetails: error.message,
                    webOrderNo: this.webOrderNo,
                })
                this.overlay = false
                // console.log(error)
                // console.log(
                //     'This order submission failed. Please try again or contact Customer First at 724.775.7926. ERROR:',
                //     error
                // )
                this.handleLoadingState('failure')
            }
        },
        getCarrierMethodString(val) {
            if (val === 'default') {
                return 'Default'
            } else if (val === 'billToMyCarrier') {
                return 'Bill To My Carrier'
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.checkbox-slot {
    p {
        margin-bottom: 0;
    }
}
</style>
